import React, { useState, useEffect, useContext } from "react";
import CardTableListManager from "../CardTableListManager";
import api from "../../services/api";
import { CountagesContext } from "../../context/countages";
import { ClientContext } from "../../context/client";
import { BigHead } from "@bigheads/core";
import { ModalContext } from "../../context/modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip as ReactTooltip } from "react-tooltip";

import InputSearchUser from "../InputSearchUser";
import InputUsers from "../InputUsers";
import ImageModal from "../ImageModal";
import { useTranslation } from "react-i18next";

const TableListManager = ({ page }) => {
  const { t } = useTranslation();
  /* CLIENT CONTEXT */
  const { dataClient, typeGet, clientType, totalCounts, setTotalCounts } =
    useContext(ClientContext);
  const { redirectToPage } = useContext(ModalContext);
  const { data, setCountageFile } = useContext(CountagesContext);

  const [countages, setCountages] = useState([]);
  const [valueArray, setValueArray] = useState();
  const [keysCountages, setKeysCountages] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);

  const [totalPages, setTotalPages] = useState(1);
  const [stateInput, setStateInput] = useState(false);

  const [stateInputParticipants, setStateInputParticipants] = useState(false);
  const [usersInCountage, setUserInCountage] = useState([]);

  const [idEdit, setIdEdit] = useState();
  const [listParticipants, setListParticipants] = useState([]);
  const [selectType, setSelectType] = useState("");

  const [imageSrc, setImageSrc] = useState("");
  const [isActiveModalImage, setIsActiveModalImage] = useState(false);
  const [optionAdm, setOptionAdm] = useState(false);

  // const getProfile = async () => {
  //     const token = localStorage.getItem("@USER_TOKEN")

  //     console.log(token)

  //     if (token) {
  //         const response = await api.post("profile/token", { token: token })

  //         if (response.data.permission == "Administrativo") {
  //             setOptionAdm(true)
  //         }

  //     }
  // }

  // const get = async (num) => {
  //     try {

  //         const response = await api.get(`countage?page=${num}`)

  //         console.log(response)
  //         if (response.status >= 404) {
  //             setCountages([]);
  //             return false;
  //         }

  //         const { data, totalPages, totalCount } = response.data;

  //         console.log(response.data)

  //         setCurrentPage(page);
  //         setTotalCounts(totalCount)
  //         setTotalPages(totalPages);

  //         if (num === 1) {
  //             setCountages(data);
  //         } else {
  //             setCountages((prevCountages) => [...prevCountages, ...data]);
  //         }

  //         setValueArray(data.length);
  //     } catch (error) {
  //         console.error(error);
  //     }
  // };

  // const getClient = async (nextPage) => {
  //     try {
  //         const response = await api.get(`countage/by/inventary/${typeGet[1]}?page=${nextPage}`)

  //         console.log(response)

  //         if (response.status == 404) {
  //             //setCountages([])
  //             return false
  //         } else {

  //             const { data, totalPages, totalCount } = response.data;

  //             console.log(totalPages, "<===")
  //             setTotalCounts(totalCount)
  //             setCurrentPage(nextPage);
  //             setTotalPages(totalPages);

  //             if (nextPage === 1) {
  //                 setCountages(data);
  //             } else {
  //                 setCountages((prevCountages) => [...prevCountages, ...data]);
  //             }
  //         }
  //     } catch (error) {

  //     }
  // }

  // const getTypeClient = async (nextPage) => {
  //     try {
  //         const response = await api.get(`countage/by/inventary/${clientType}/${typeGet[1]}?page=${nextPage}`)

  //         if (response.status == 404) {
  //             //setCountages([])
  //             return false
  //         } else {

  //             const { data, totalPages, totalCount } = response.data;

  //             setTotalCounts(totalCount)
  //             setCurrentPage(nextPage);
  //             setTotalPages(totalPages);

  //             if (nextPage === 1) {
  //                 setCountages(data);
  //             } else {
  //                 setCountages((prevCountages) => [...prevCountages, ...data]);
  //             }
  //         }
  //     } catch (error) {

  //     }
  // }

  // const getTypeClientLocation = async (nextPage) => {
  //     try {
  //         const response = await api.get(`countage/by/inventary/${clientType}/location/${typeGet[1]}?page=${nextPage}`)

  //         if (response.status == 404) {
  //             // setCountages([])
  //             return false
  //         } else {

  //             const { data, totalPages, totalCount } = response.data;

  //             setTotalCounts(totalCount)
  //             setCurrentPage(nextPage);
  //             setTotalPages(totalPages);

  //             if (nextPage === 1) {
  //                 setCountages(data);
  //             } else {
  //                 setCountages((prevCountages) => [...prevCountages, ...data]);
  //             }
  //         }
  //     } catch (error) {

  //     }
  // }

  const getProfile = async () => {
    try {
      const token = localStorage.getItem("@USER_TOKEN");

      if (!token) {
        throw new Error("Token não encontrado.");
      }

      const response = await api.post("profile/token", { token });

      if (response.data.permission === "Administrativo") {
        setOptionAdm(true);
      }
    } catch (error) {
      console.error(error);
      toast.error("Erro ao obter perfil. Tente novamente.");
    }
  };

  const get = async (num) => {
    try {
      const response = await api.get(`countage?page=${num}`);

      if (response.status >= 404) {
        setCountages([]);
        return false;
      }

      const { data, totalPages, totalCount } = response.data;

      setCurrentPage(num);
      setTotalCounts(totalCount);
      setTotalPages(totalPages);

      if (num === 1) {
        setCountages(data);
      } else {
        setCountages((prevCountages) => [...prevCountages, ...data]);
      }

      setValueArray(data.length);
    } catch (error) {
      console.error(error);
      toast.error("Erro ao obter dados. Tente novamente.");
    }
  };

  const getClient = async (nextPage) => {
    try {
      const response = await api.get(
        `countage/by/inventary/${typeGet[1]}?page=${nextPage}`
      );

      if (response.status === 404) {
        return false;
      }

      const { data, totalPages, totalCount } = response.data;

      setTotalCounts(totalCount);
      setCurrentPage(nextPage);
      setTotalPages(totalPages);

      if (nextPage === 1) {
        setCountages(data);
      } else {
        setCountages((prevCountages) => [...prevCountages, ...data]);
      }
    } catch (error) {
      console.error(error);
      toast.error("Erro ao obter clientes. Tente novamente.");
    }
  };

  const getTypeClient = async (nextPage) => {
    try {
      const response = await api.get(
        `countage/by/inventary/${clientType}/${typeGet[1]}?page=${nextPage}`
      );

      if (response.status === 404) {
        return false;
      }

      const { data, totalPages, totalCount } = response.data;

      setTotalCounts(totalCount);
      setCurrentPage(nextPage);
      setTotalPages(totalPages);

      if (nextPage === 1) {
        setCountages(data);
      } else {
        setCountages((prevCountages) => [...prevCountages, ...data]);
      }
    } catch (error) {
      console.error(error);
      toast.error("Erro ao obter tipo de cliente. Tente novamente.");
    }
  };

  const getTypeClientLocation = async (nextPage) => {
    try {
      const response = await api.get(
        `countage/by/inventary/${clientType}/location/${typeGet[1]}?page=${nextPage}`
      );

      if (response.status === 404) {
        return false;
      }

      const { data, totalPages, totalCount } = response.data;

      setTotalCounts(totalCount);
      setCurrentPage(nextPage);
      setTotalPages(totalPages);

      if (nextPage === 1) {
        setCountages(data);
      } else {
        setCountages((prevCountages) => [...prevCountages, ...data]);
      }
    } catch (error) {
      console.error(error);
      toast.error("Erro ao obter localização de cliente. Tente novamente.");
    }
  };

  useEffect(() => {
    get(1);
    getProfile();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
    setTotalPages(2);
  }, [typeGet[0]]);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } =
        document.documentElement;

      if (scrollTop + clientHeight >= scrollHeight - 2) {
        // Verifica se a página atual é menor que o total de páginas
        console.log(currentPage, totalPages);

        if (currentPage < totalPages) {
          if (typeGet[0] == "client") {
            if (selectType != typeGet[1]) {
              setSelectType(typeGet[1]);
            }
            const nextPage = currentPage + 1;

            getClient(nextPage);
          }
          if (typeGet[0] == "count") {
            if (selectType != typeGet[1]) {
              setSelectType(typeGet[1]);
            }
            const nextPage = currentPage + 1;

            getTypeClient(nextPage);
          }
          if (typeGet[0] == "location") {
            if (selectType != typeGet[1]) {
              setSelectType(typeGet[1]);
            }
            const nextPage = currentPage + 1;

            getTypeClientLocation(nextPage);
          }
          if (
            typeGet[0] != "client" &&
            typeGet[0] != "count" &&
            typeGet[0] != "location"
          ) {
            const nextPage = currentPage + 1;
            get(nextPage);
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [currentPage, totalPages, typeGet]);

  useEffect(() => {
    if (String(data).length > 0) {
      setCountages(data);
    }
  }, [data]);

  useEffect(() => {
    if (dataClient != undefined) {
      setCountages(dataClient);
    }
  }, [dataClient]);

  useEffect(() => {
    const headers2 = [
      { label: "ID", key: "id" },
      { label: "Tipo de contagem", key: "typeCount" },
      { label: "Cliente", key: "client" },
      { label: "Depósito", key: "deposit" },
      { label: "Local ou Filial", key: "location" },
      { label: "Descrição", key: "description" },
      { label: "Código de Barras", key: "product" },
      { label: "Lote", key: "batch" },
      { label: "Série", key: "series" },
      { label: "Código do Produto", key: "productCode" },
      { label: "Validade", key: "validate" },
      { label: "Fabricação", key: "manufacture" },
      { label: "Tipo de Estrutura", key: "typeStructure" },
      { label: "Temperatura", key: "temperature" },
      { label: "Endereço", key: "address" },
      { label: "Valor Unitário", key: "unitaryValue" },
      { label: "Valor Inicial", key: "initialValue" },
      { label: "Status", key: "statusStock" },
      { label: "Comentários", key: "comments" },
      { label: "Motivos de Erros", key: "reasonErrors" },
      { label: "Status de Contagem", key: "statusCountage" },
      { label: "Primeiro Valor", key: "primaryValue" },
      { label: "Segundo Valor", key: "secondaryValue" },
      { label: "Terceiro Valor", key: "threeValue" },
      { label: "Quarto Valor", key: "fourValue" },
      { label: "Variação", key: "variation" },
      { label: "Data de Criação", key: "createdAt" },
      { label: "Data de Atualização", key: "updatedAt" },
    ];

    if (countages?.length > 0) {
      const csvReport = {
        filename: "report.xls",
        headers: headers2,
        data: countages,
      };

      setCountageFile(csvReport);
    }
  }, [countages]);

  return (
    <>
      <div
        id="test2"
        style={{
          height: `${
            valueArray < 5 || valueArray == 0 || String(dataClient)?.length == 0
              ? "100vh"
              : "100%"
          }`,
          overflowX: "hidden",
          overflowY: "hidden",
          marginBottom: "100px",
        }}
      >
        <ToastContainer />

        {countages?.length > 0 &&
          countages.map((itemCountage) => {
            return (
              <div
                style={{
                  height: "89px",
                  width:
                    usersInCountage?.length == 0 || usersInCountage?.length == 1
                      ? "3350px"
                      : "3350px",
                  borderRadius: "10px",
                  border: "1px solid #D7D7D7",
                  background: "white",
                  display: "flex",
                  paddingTop: "15px",
                  paddingLeft: "20px",
                  marginTop: "0.8125rem",
                  position: "relative",
                }}
              >
                {page == "Inventary" ? (
                  <></>
                ) : stateInput == true ? (
                  <InputSearchUser
                    id={itemCountage.id}
                    idEdit={idEdit}
                    name={itemCountage.name}
                    mail={itemCountage.mail}
                    client={itemCountage.client}
                    onBlur={() =>
                      setTimeout(() => {
                        setStateInput(false);
                      }, [200])
                    }
                  />
                ) : (
                  <InputUsers
                    onClick={() => {
                      setStateInput(true);
                      setIdEdit(itemCountage.id);
                    }}
                    id={itemCountage.id}
                    client={itemCountage.client}
                  />
                )}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="typeCount"
                    data-tooltip-content={`${itemCountage.typeCount}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.typeCount}
                  </p>
                  <p className="textSecondaryListInventary">
                    {t("typeInventary")}
                  </p>
                  <ReactTooltip id="typeCount" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="typeCount"
                    data-tooltip-content={`${itemCountage.location}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.location}
                  </p>
                  <p className="textSecondaryListInventary">{t("location")}</p>
                  <ReactTooltip id="typeCount" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="deposit"
                    data-tooltip-content={`${itemCountage.deposit}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.deposit}
                  </p>
                  <p className="textSecondaryListInventary">{t("deposit")}</p>
                  <ReactTooltip id="deposit" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="address"
                    data-tooltip-content={`${itemCountage.address}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.address}
                  </p>
                  <p className="textSecondaryListInventary">{t("address")}</p>
                  <ReactTooltip id="address" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="typeStructure"
                    data-tooltip-content={`${itemCountage.typeStructure}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.typeStructure}
                  </p>
                  <p className="textSecondaryListInventary">
                    {t("typeStructure")}
                  </p>
                  <ReactTooltip id="typeStructure" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="temperature"
                    data-tooltip-content={`${itemCountage.temperature}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.temperature}
                  </p>
                  <p className="textSecondaryListInventary">
                    {t("temperature")}
                  </p>
                  <ReactTooltip id="temperature" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                    maxWidth: "320px",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="description"
                    data-tooltip-content={`${itemCountage.description}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "300px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.description}
                  </p>
                  <p className="textSecondaryListInventary">
                    {t("description")}
                  </p>
                  <ReactTooltip id="description" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="product"
                    data-tooltip-content={`${itemCountage.product}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.product}
                  </p>
                  <p className="textSecondaryListInventary">{t("barCode")}</p>
                  <ReactTooltip id="product" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="productCode"
                    data-tooltip-content={`${itemCountage.productCode}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.productCode}
                  </p>
                  <p className="textSecondaryListInventary">
                    {t("productCode")}
                  </p>
                  <ReactTooltip id="productCode" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="batch"
                    data-tooltip-content={`${itemCountage.batch}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.batch}
                  </p>
                  <p className="textSecondaryListInventary">{t("batch")}</p>
                  <ReactTooltip id="batch" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="series"
                    data-tooltip-content={`${itemCountage.series}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.series}
                  </p>
                  <p className="textSecondaryListInventary">{t("series")}</p>
                  <ReactTooltip id="series" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="validate"
                    data-tooltip-content={`${itemCountage.validate}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.validate}
                  </p>
                  <p className="textSecondaryListInventary">{t("validity")}</p>
                  <ReactTooltip id="validate" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="initialValue"
                    data-tooltip-content={`${itemCountage.initialValue}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.initialValue}
                  </p>
                  <p className="textSecondaryListInventary">
                    {t("initialValue")}
                  </p>
                  <ReactTooltip id="initialValue" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="primaryValue"
                    data-tooltip-content={`${itemCountage.primaryValue}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.primaryValue != undefined
                      ? itemCountage.primaryValue
                      : "-"}
                  </p>
                  <p className="textSecondaryListInventary">
                    {t("primaryValue")}
                  </p>
                  <ReactTooltip id="primaryValue" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="secondaryValue"
                    data-tooltip-content={`${itemCountage.secondaryValue}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.secondaryValue != undefined
                      ? itemCountage.secondaryValue
                      : "-"}
                  </p>
                  <p className="textSecondaryListInventary">
                    {t("secondaryValue")}
                  </p>
                  <ReactTooltip id="secondaryValue" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="threeValue"
                    data-tooltip-content={`${itemCountage.threeValue}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.threeValue != undefined
                      ? itemCountage.threeValue
                      : "-"}
                  </p>
                  <p className="textSecondaryListInventary">
                    {t("threeValue")}
                  </p>
                  <ReactTooltip id="threeValue" />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="fourValue"
                    data-tooltip-content={`${itemCountage.fourValue}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "100px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.fourValue != undefined
                      ? itemCountage.fourValue
                      : "-"}
                  </p>
                  <p className="textSecondaryListInventary">{t("fourValue")}</p>
                  <ReactTooltip id="fourValue" />
                </div>

                {
                  itemCountage.comments == null ? <></> : <></>
                  /*<div style={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}>
                                    <p data-tooltip-place='top' data-tooltip-position-strategy='fixed' data-tooltip-id="comments" data-tooltip-content={`${itemCountage.comments}`} className="textPrimartyListInventary" style={{ width: "100px", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer" }}>{itemCountage.comments != undefined ? itemCountage.comments : "-"}</p>
                                    <p className="textSecondaryListInventary">Comentários</p>
                                    <ReactTooltip id='comments' />
                                </div>*/
                }
                {page == "Inventary" ? (
                  <>
                    {itemCountage.statusCountage == "leftover" ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        <p
                          data-tooltip-place="top"
                          data-tooltip-position-strategy="fixed"
                          data-tooltip-id="fourValue"
                          data-tooltip-content={`${
                            itemCountage.fourValue ||
                            itemCountage.threeValue ||
                            itemCountage.secondaryValue ||
                            itemCountage.primaryValue
                          }`}
                          className="textPrimartyListInventary"
                          style={{
                            width: "100px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                          }}
                        >
                          {itemCountage.fourValue ||
                            itemCountage.threeValue ||
                            itemCountage.secondaryValue ||
                            itemCountage.primaryValue}
                        </p>
                        <p className="textSecondaryListInventary">
                          {t("finalBalance")}
                        </p>
                        <ReactTooltip id="fourValue" />
                      </div>
                    ) : itemCountage.statusCountage == "false" ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        <p
                          data-tooltip-place="top"
                          data-tooltip-position-strategy="fixed"
                          data-tooltip-id="fourValue"
                          data-tooltip-content={`${
                            itemCountage.fourValue ||
                            itemCountage.threeValue ||
                            itemCountage.secondaryValue ||
                            itemCountage.primaryValue
                          }`}
                          className="textPrimartyListInventary"
                          style={{
                            width: "100px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                          }}
                        >
                          {itemCountage.fourValue ||
                            itemCountage.threeValue ||
                            itemCountage.secondaryValue ||
                            itemCountage.primaryValue}
                        </p>
                        <p className="textSecondaryListInventary">
                          {t("finalBalance")}
                        </p>
                        <ReactTooltip id="fourValue" />
                      </div>
                    ) : itemCountage.statusCountage == "true" ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        <p
                          data-tooltip-place="top"
                          data-tooltip-position-strategy="fixed"
                          data-tooltip-id="primaryValue"
                          data-tooltip-content={`${
                            itemCountage.fourValue ||
                            itemCountage.threeValue ||
                            itemCountage.secondaryValue ||
                            itemCountage.primaryValue
                          }`}
                          className="textPrimartyListInventary"
                          style={{
                            width: "100px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                          }}
                        >
                          {itemCountage.fourValue ||
                            itemCountage.threeValue ||
                            itemCountage.secondaryValue ||
                            itemCountage.primaryValue}
                        </p>
                        <p className="textSecondaryListInventary">
                          {t("finalBalance")}
                        </p>
                        <ReactTooltip id="primaryValue" />
                      </div>
                    ) : (
                      <></>
                    )}

                    {itemCountage.statusCountage == "leftover" ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        <p
                          data-tooltip-place="top"
                          data-tooltip-position-strategy="fixed"
                          data-tooltip-id="variation"
                          data-tooltip-content={`${itemCountage.variation}`}
                          className="textPrimartyListInventary"
                          style={{
                            width: "100px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                          }}
                        >
                          +{itemCountage.variation}
                        </p>
                        <p className="textSecondaryListInventary">
                          {t("variation")}
                        </p>
                        <ReactTooltip id="variation" />
                      </div>
                    ) : itemCountage.statusCountage == "false" ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        <p
                          data-tooltip-place="top"
                          data-tooltip-position-strategy="fixed"
                          data-tooltip-id="variation"
                          data-tooltip-content={`${itemCountage.variation}`}
                          className="textPrimartyListInventary"
                          style={{
                            width: "100px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                          }}
                        >
                          {itemCountage.variation}
                        </p>
                        <p className="textSecondaryListInventary">
                          {t("variation")}
                        </p>
                        <ReactTooltip id="variation" />
                      </div>
                    ) : itemCountage.statusCountage == "true" ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        <p
                          data-tooltip-place="top"
                          data-tooltip-position-strategy="fixed"
                          data-tooltip-id="variation"
                          data-tooltip-content={`${itemCountage.variation}`}
                          className="textPrimartyListInventary"
                          style={{
                            width: "100px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "pointer",
                          }}
                        >
                          {itemCountage.variation}
                        </p>
                        <p className="textSecondaryListInventary">
                          {t("variation")}
                        </p>
                        <ReactTooltip id="variation" />
                      </div>
                    ) : (
                      <></>
                    )}

                    {itemCountage.statusCountage == "true" ? (
                      <svg
                        width="142"
                        height="32"
                        viewBox="0 0 142 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="142" height="32" rx="16" fill="#E0FFF0" />
                        <path
                          d="M38.9419 12.161V14.813H42.0619V16.022H38.9419V18.791H42.4519V20H37.4599V10.952H42.4519V12.161H38.9419ZM46.5439 20.117C45.9806 20.117 45.4736 20.0173 45.0229 19.818C44.5809 19.61 44.2299 19.3327 43.9699 18.986C43.7099 18.6307 43.5712 18.2363 43.5539 17.803H45.0879C45.1139 18.1063 45.2569 18.362 45.5169 18.57C45.7856 18.7693 46.1192 18.869 46.5179 18.869C46.9339 18.869 47.2546 18.791 47.4799 18.635C47.7139 18.4703 47.8309 18.2623 47.8309 18.011C47.8309 17.7423 47.7009 17.543 47.4409 17.413C47.1896 17.283 46.7866 17.14 46.2319 16.984C45.6946 16.8367 45.2569 16.6937 44.9189 16.555C44.5809 16.4163 44.2862 16.204 44.0349 15.918C43.7922 15.632 43.6709 15.255 43.6709 14.787C43.6709 14.4057 43.7836 14.059 44.0089 13.747C44.2342 13.4263 44.5549 13.175 44.9709 12.993C45.3956 12.811 45.8809 12.72 46.4269 12.72C47.2416 12.72 47.8959 12.928 48.3899 13.344C48.8926 13.7513 49.1612 14.3103 49.1959 15.021H47.7139C47.6879 14.7003 47.5579 14.4447 47.3239 14.254C47.0899 14.0633 46.7736 13.968 46.3749 13.968C45.9849 13.968 45.6859 14.0417 45.4779 14.189C45.2699 14.3363 45.1659 14.5313 45.1659 14.774C45.1659 14.9647 45.2352 15.125 45.3739 15.255C45.5126 15.385 45.6816 15.489 45.8809 15.567C46.0802 15.6363 46.3749 15.7273 46.7649 15.84C47.2849 15.9787 47.7096 16.1217 48.0389 16.269C48.3769 16.4077 48.6672 16.6157 48.9099 16.893C49.1526 17.1703 49.2782 17.5387 49.2869 17.998C49.2869 18.4053 49.1742 18.7693 48.9489 19.09C48.7236 19.4107 48.4029 19.662 47.9869 19.844C47.5796 20.026 47.0986 20.117 46.5439 20.117ZM52.2839 14.046V18.011C52.2839 18.2797 52.3446 18.4747 52.4659 18.596C52.5959 18.7087 52.8126 18.765 53.1159 18.765H54.0259V20H52.8559C52.1886 20 51.6772 19.844 51.3219 19.532C50.9666 19.22 50.7889 18.713 50.7889 18.011V14.046H49.9439V12.837H50.7889V11.056H52.2839V12.837H54.0259V14.046H52.2839ZM58.1655 20.117C57.4895 20.117 56.8785 19.9653 56.3325 19.662C55.7865 19.35 55.3575 18.9167 55.0455 18.362C54.7335 17.7987 54.5775 17.1487 54.5775 16.412C54.5775 15.684 54.7378 15.0383 55.0585 14.475C55.3792 13.9117 55.8168 13.4783 56.3715 13.175C56.9262 12.8717 57.5458 12.72 58.2305 12.72C58.9152 12.72 59.5348 12.8717 60.0895 13.175C60.6442 13.4783 61.0818 13.9117 61.4025 14.475C61.7232 15.0383 61.8835 15.684 61.8835 16.412C61.8835 17.14 61.7188 17.7857 61.3895 18.349C61.0602 18.9123 60.6095 19.35 60.0375 19.662C59.4742 19.9653 58.8502 20.117 58.1655 20.117ZM58.1655 18.83C58.5468 18.83 58.9022 18.739 59.2315 18.557C59.5695 18.375 59.8425 18.102 60.0505 17.738C60.2585 17.374 60.3625 16.932 60.3625 16.412C60.3625 15.892 60.2628 15.4543 60.0635 15.099C59.8642 14.735 59.5998 14.462 59.2705 14.28C58.9412 14.098 58.5858 14.007 58.2045 14.007C57.8232 14.007 57.4678 14.098 57.1385 14.28C56.8178 14.462 56.5622 14.735 56.3715 15.099C56.1808 15.4543 56.0855 15.892 56.0855 16.412C56.0855 17.1833 56.2805 17.7813 56.6705 18.206C57.0692 18.622 57.5675 18.83 58.1655 18.83ZM62.5212 16.386C62.5212 15.6667 62.6685 15.0297 62.9632 14.475C63.2665 13.9203 63.6739 13.4913 64.1852 13.188C64.7052 12.876 65.2815 12.72 65.9142 12.72C66.4689 12.72 66.9585 12.8327 67.3832 13.058C67.8165 13.2833 68.1502 13.5563 68.3842 13.877V12.837H69.8792V23.406H68.3842V18.96C68.1502 19.2807 67.8122 19.5537 67.3702 19.779C66.9282 20.0043 66.4255 20.117 65.8622 20.117C65.2469 20.117 64.6835 19.961 64.1722 19.649C63.6695 19.3283 63.2665 18.8863 62.9632 18.323C62.6685 17.751 62.5212 17.1053 62.5212 16.386ZM68.3842 16.412C68.3842 15.918 68.2802 15.489 68.0722 15.125C67.8729 14.761 67.6085 14.4837 67.2792 14.293C66.9499 14.1023 66.5945 14.007 66.2132 14.007C65.8319 14.007 65.4765 14.1023 65.1472 14.293C64.8179 14.475 64.5492 14.748 64.3412 15.112C64.1419 15.4673 64.0422 15.892 64.0422 16.386C64.0422 16.88 64.1419 17.3133 64.3412 17.686C64.5492 18.0587 64.8179 18.3447 65.1472 18.544C65.4852 18.7347 65.8405 18.83 66.2132 18.83C66.5945 18.83 66.9499 18.7347 67.2792 18.544C67.6085 18.3533 67.8729 18.076 68.0722 17.712C68.2802 17.3393 68.3842 16.906 68.3842 16.412ZM77.9794 12.837V20H76.4974V19.155C76.2634 19.4497 75.9557 19.6837 75.5744 19.857C75.2017 20.0217 74.8031 20.104 74.3784 20.104C73.8151 20.104 73.3081 19.987 72.8574 19.753C72.4154 19.519 72.0644 19.1723 71.8044 18.713C71.5531 18.2537 71.4274 17.699 71.4274 17.049V12.837H72.8964V16.828C72.8964 17.4693 73.0567 17.9633 73.3774 18.31C73.6981 18.648 74.1357 18.817 74.6904 18.817C75.2451 18.817 75.6827 18.648 76.0034 18.31C76.3327 17.9633 76.4974 17.4693 76.4974 16.828V12.837H77.9794ZM86.1665 16.243C86.1665 16.5117 86.1491 16.7543 86.1145 16.971H80.6415C80.6848 17.543 80.8971 18.0023 81.2785 18.349C81.6598 18.6957 82.1278 18.869 82.6825 18.869C83.4798 18.869 84.0431 18.5353 84.3725 17.868H85.9715C85.7548 18.5267 85.3605 19.0683 84.7885 19.493C84.2251 19.909 83.5231 20.117 82.6825 20.117C81.9978 20.117 81.3825 19.9653 80.8365 19.662C80.2991 19.35 79.8745 18.9167 79.5625 18.362C79.2591 17.7987 79.1075 17.1487 79.1075 16.412C79.1075 15.6753 79.2548 15.0297 79.5495 14.475C79.8528 13.9117 80.2731 13.4783 80.8105 13.175C81.3565 12.8717 81.9805 12.72 82.6825 12.72C83.3585 12.72 83.9608 12.8673 84.4895 13.162C85.0181 13.4567 85.4298 13.8727 85.7245 14.41C86.0191 14.9387 86.1665 15.5497 86.1665 16.243ZM84.6195 15.775C84.6108 15.229 84.4158 14.7913 84.0345 14.462C83.6531 14.1327 83.1808 13.968 82.6175 13.968C82.1061 13.968 81.6685 14.1327 81.3045 14.462C80.9405 14.7827 80.7238 15.2203 80.6545 15.775H84.6195ZM93.4422 20.117C92.7662 20.117 92.1552 19.9653 91.6092 19.662C91.0632 19.35 90.6342 18.9167 90.3222 18.362C90.0102 17.7987 89.8542 17.1487 89.8542 16.412C89.8542 15.684 90.0145 15.0383 90.3352 14.475C90.6559 13.9117 91.0935 13.4783 91.6482 13.175C92.2029 12.8717 92.8225 12.72 93.5072 12.72C94.1919 12.72 94.8115 12.8717 95.3662 13.175C95.9209 13.4783 96.3585 13.9117 96.6792 14.475C96.9999 15.0383 97.1602 15.684 97.1602 16.412C97.1602 17.14 96.9955 17.7857 96.6662 18.349C96.3369 18.9123 95.8862 19.35 95.3142 19.662C94.7509 19.9653 94.1269 20.117 93.4422 20.117ZM93.4422 18.83C93.8235 18.83 94.1789 18.739 94.5082 18.557C94.8462 18.375 95.1192 18.102 95.3272 17.738C95.5352 17.374 95.6392 16.932 95.6392 16.412C95.6392 15.892 95.5395 15.4543 95.3402 15.099C95.1409 14.735 94.8765 14.462 94.5472 14.28C94.2179 14.098 93.8625 14.007 93.4812 14.007C93.0999 14.007 92.7445 14.098 92.4152 14.28C92.0945 14.462 91.8389 14.735 91.6482 15.099C91.4575 15.4543 91.3622 15.892 91.3622 16.412C91.3622 17.1833 91.5572 17.7813 91.9472 18.206C92.3459 18.622 92.8442 18.83 93.4422 18.83ZM101.126 16.425L104.428 20H102.426L99.7739 16.919V20H98.2919V10.38H99.7739V15.97L102.374 12.837H104.428L101.126 16.425Z"
                          fill="#00B386"
                        />
                      </svg>
                    ) : itemCountage.statusCountage == "leftover" ? (
                      <svg
                        width="142"
                        height="32"
                        viewBox="0 0 142 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="142" height="32" rx="16" fill="#FFFBD2" />
                        <path
                          d="M55.7456 20.091C55.139 20.091 54.593 19.987 54.1076 19.779C53.6223 19.5623 53.241 19.259 52.9636 18.869C52.6863 18.479 52.5476 18.024 52.5476 17.504H54.1336C54.1683 17.894 54.32 18.2147 54.5886 18.466C54.866 18.7173 55.2516 18.843 55.7456 18.843C56.257 18.843 56.6556 18.7217 56.9416 18.479C57.2276 18.2277 57.3706 17.907 57.3706 17.517C57.3706 17.2137 57.2796 16.9667 57.0976 16.776C56.9243 16.5853 56.7033 16.438 56.4346 16.334C56.1746 16.23 55.8106 16.1173 55.3426 15.996C54.7533 15.84 54.2723 15.684 53.8996 15.528C53.5356 15.3633 53.2236 15.112 52.9636 14.774C52.7036 14.436 52.5736 13.9853 52.5736 13.422C52.5736 12.902 52.7036 12.447 52.9636 12.057C53.2236 11.667 53.5876 11.368 54.0556 11.16C54.5236 10.952 55.0653 10.848 55.6806 10.848C56.556 10.848 57.271 11.069 57.8256 11.511C58.389 11.9443 58.701 12.5423 58.7616 13.305H57.1236C57.0976 12.9757 56.9416 12.694 56.6556 12.46C56.3696 12.226 55.9926 12.109 55.5246 12.109C55.1 12.109 54.7533 12.2173 54.4846 12.434C54.216 12.6507 54.0816 12.9627 54.0816 13.37C54.0816 13.6473 54.164 13.877 54.3286 14.059C54.502 14.2323 54.7186 14.371 54.9786 14.475C55.2386 14.579 55.594 14.6917 56.0446 14.813C56.6426 14.9777 57.128 15.1423 57.5006 15.307C57.882 15.4717 58.2026 15.7273 58.4626 16.074C58.7313 16.412 58.8656 16.867 58.8656 17.439C58.8656 17.8983 58.74 18.3317 58.4886 18.739C58.246 19.1463 57.8863 19.4757 57.4096 19.727C56.9416 19.9697 56.387 20.091 55.7456 20.091ZM63.388 20.117C62.712 20.117 62.101 19.9653 61.555 19.662C61.009 19.35 60.58 18.9167 60.268 18.362C59.956 17.7987 59.8 17.1487 59.8 16.412C59.8 15.684 59.9603 15.0383 60.281 14.475C60.6017 13.9117 61.0393 13.4783 61.594 13.175C62.1487 12.8717 62.7683 12.72 63.453 12.72C64.1377 12.72 64.7573 12.8717 65.312 13.175C65.8667 13.4783 66.3043 13.9117 66.625 14.475C66.9457 15.0383 67.106 15.684 67.106 16.412C67.106 17.14 66.9413 17.7857 66.612 18.349C66.2827 18.9123 65.832 19.35 65.26 19.662C64.6967 19.9653 64.0727 20.117 63.388 20.117ZM63.388 18.83C63.7693 18.83 64.1247 18.739 64.454 18.557C64.792 18.375 65.065 18.102 65.273 17.738C65.481 17.374 65.585 16.932 65.585 16.412C65.585 15.892 65.4853 15.4543 65.286 15.099C65.0867 14.735 64.8223 14.462 64.493 14.28C64.1637 14.098 63.8083 14.007 63.427 14.007C63.0457 14.007 62.6903 14.098 62.361 14.28C62.0403 14.462 61.7847 14.735 61.594 15.099C61.4033 15.4543 61.308 15.892 61.308 16.412C61.308 17.1833 61.503 17.7813 61.893 18.206C62.2917 18.622 62.79 18.83 63.388 18.83ZM69.7197 13.903C69.971 13.5563 70.3134 13.2747 70.7467 13.058C71.1887 12.8327 71.6784 12.72 72.2157 12.72C72.8484 12.72 73.4204 12.8717 73.9317 13.175C74.443 13.4783 74.846 13.9117 75.1407 14.475C75.4354 15.0297 75.5827 15.6667 75.5827 16.386C75.5827 17.1053 75.4354 17.751 75.1407 18.323C74.846 18.8863 74.4387 19.3283 73.9187 19.649C73.4074 19.961 72.8397 20.117 72.2157 20.117C71.661 20.117 71.167 20.0087 70.7337 19.792C70.309 19.5753 69.971 19.298 69.7197 18.96V20H68.2377V10.38H69.7197V13.903ZM74.0747 16.386C74.0747 15.892 73.9707 15.4673 73.7627 15.112C73.5634 14.748 73.2947 14.475 72.9567 14.293C72.6274 14.1023 72.272 14.007 71.8907 14.007C71.518 14.007 71.1627 14.1023 70.8247 14.293C70.4954 14.4837 70.2267 14.761 70.0187 15.125C69.8194 15.489 69.7197 15.918 69.7197 16.412C69.7197 16.906 69.8194 17.3393 70.0187 17.712C70.2267 18.076 70.4954 18.3533 70.8247 18.544C71.1627 18.7347 71.518 18.83 71.8907 18.83C72.272 18.83 72.6274 18.7347 72.9567 18.544C73.2947 18.3447 73.5634 18.0587 73.7627 17.686C73.9707 17.3133 74.0747 16.88 74.0747 16.386ZM78.1969 13.877C78.4136 13.513 78.6996 13.2313 79.0549 13.032C79.4189 12.824 79.8479 12.72 80.3419 12.72V14.254H79.9649C79.3842 14.254 78.9422 14.4013 78.6389 14.696C78.3442 14.9907 78.1969 15.502 78.1969 16.23V20H76.7149V12.837H78.1969V13.877ZM80.8768 16.386C80.8768 15.6667 81.0242 15.0297 81.3188 14.475C81.6222 13.9203 82.0295 13.4913 82.5408 13.188C83.0608 12.876 83.6328 12.72 84.2568 12.72C84.8202 12.72 85.3098 12.8327 85.7258 13.058C86.1505 13.2747 86.4885 13.5477 86.7398 13.877V12.837H88.2348V20H86.7398V18.934C86.4885 19.272 86.1462 19.5537 85.7128 19.779C85.2795 20.0043 84.7855 20.117 84.2308 20.117C83.6155 20.117 83.0522 19.961 82.5408 19.649C82.0295 19.3283 81.6222 18.8863 81.3188 18.323C81.0242 17.751 80.8768 17.1053 80.8768 16.386ZM86.7398 16.412C86.7398 15.918 86.6358 15.489 86.4278 15.125C86.2285 14.761 85.9642 14.4837 85.6348 14.293C85.3055 14.1023 84.9502 14.007 84.5688 14.007C84.1875 14.007 83.8322 14.1023 83.5028 14.293C83.1735 14.475 82.9048 14.748 82.6968 15.112C82.4975 15.4673 82.3978 15.892 82.3978 16.386C82.3978 16.88 82.4975 17.3133 82.6968 17.686C82.9048 18.0587 83.1735 18.3447 83.5028 18.544C83.8408 18.7347 84.1962 18.83 84.5688 18.83C84.9502 18.83 85.3055 18.7347 85.6348 18.544C85.9642 18.3533 86.2285 18.076 86.4278 17.712C86.6358 17.3393 86.7398 16.906 86.7398 16.412Z"
                          fill="#C6B200"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="142"
                        height="32"
                        viewBox="0 0 142 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="142" height="32" rx="16" fill="#FFE1E1" />
                        <path
                          d="M61.6706 10.965V12.174H57.8356V14.839H60.8256V16.048H57.8356V20H56.3536V10.965H61.6706ZM62.2167 16.386C62.2167 15.6667 62.364 15.0297 62.6587 14.475C62.962 13.9203 63.3693 13.4913 63.8807 13.188C64.4007 12.876 64.9727 12.72 65.5967 12.72C66.16 12.72 66.6497 12.8327 67.0657 13.058C67.4903 13.2747 67.8283 13.5477 68.0797 13.877V12.837H69.5747V20H68.0797V18.934C67.8283 19.272 67.486 19.5537 67.0527 19.779C66.6193 20.0043 66.1253 20.117 65.5707 20.117C64.9553 20.117 64.392 19.961 63.8807 19.649C63.3693 19.3283 62.962 18.8863 62.6587 18.323C62.364 17.751 62.2167 17.1053 62.2167 16.386ZM68.0797 16.412C68.0797 15.918 67.9757 15.489 67.7677 15.125C67.5683 14.761 67.304 14.4837 66.9747 14.293C66.6453 14.1023 66.29 14.007 65.9087 14.007C65.5273 14.007 65.172 14.1023 64.8427 14.293C64.5133 14.475 64.2447 14.748 64.0367 15.112C63.8373 15.4673 63.7377 15.892 63.7377 16.386C63.7377 16.88 63.8373 17.3133 64.0367 17.686C64.2447 18.0587 64.5133 18.3447 64.8427 18.544C65.1807 18.7347 65.536 18.83 65.9087 18.83C66.29 18.83 66.6453 18.7347 66.9747 18.544C67.304 18.3533 67.5683 18.076 67.7677 17.712C67.9757 17.3393 68.0797 16.906 68.0797 16.412ZM72.6699 10.38V20H71.1879V10.38H72.6699ZM76.0113 14.046V18.011C76.0113 18.2797 76.072 18.4747 76.1933 18.596C76.3233 18.7087 76.54 18.765 76.8433 18.765H77.7533V20H76.5833C75.916 20 75.4046 19.844 75.0493 19.532C74.694 19.22 74.5163 18.713 74.5163 18.011V14.046H73.6713V12.837H74.5163V11.056H76.0113V12.837H77.7533V14.046H76.0113ZM78.2919 16.386C78.2919 15.6667 78.4392 15.0297 78.7339 14.475C79.0372 13.9203 79.4445 13.4913 79.9559 13.188C80.4759 12.876 81.0479 12.72 81.6719 12.72C82.2352 12.72 82.7249 12.8327 83.1409 13.058C83.5655 13.2747 83.9035 13.5477 84.1549 13.877V12.837H85.6499V20H84.1549V18.934C83.9035 19.272 83.5612 19.5537 83.1279 19.779C82.6945 20.0043 82.2005 20.117 81.6459 20.117C81.0305 20.117 80.4672 19.961 79.9559 19.649C79.4445 19.3283 79.0372 18.8863 78.7339 18.323C78.4392 17.751 78.2919 17.1053 78.2919 16.386ZM84.1549 16.412C84.1549 15.918 84.0509 15.489 83.8429 15.125C83.6435 14.761 83.3792 14.4837 83.0499 14.293C82.7205 14.1023 82.3652 14.007 81.9839 14.007C81.6025 14.007 81.2472 14.1023 80.9179 14.293C80.5885 14.475 80.3199 14.748 80.1119 15.112C79.9125 15.4673 79.8129 15.892 79.8129 16.386C79.8129 16.88 79.9125 17.3133 80.1119 17.686C80.3199 18.0587 80.5885 18.3447 80.9179 18.544C81.2559 18.7347 81.6112 18.83 81.9839 18.83C82.3652 18.83 82.7205 18.7347 83.0499 18.544C83.3792 18.3533 83.6435 18.076 83.8429 17.712C84.0509 17.3393 84.1549 16.906 84.1549 16.412Z"
                          fill="#EA0000"
                        />
                      </svg>
                    )}

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        position: "relative",
                      }}
                    >
                      <p
                        data-tooltip-place="top"
                        data-tooltip-position-strategy="fixed"
                        data-tooltip-id="comments"
                        data-tooltip-content={`${itemCountage.comments}`}
                        className="textPrimartyListInventary"
                        style={{
                          width: "300px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          cursor: "pointer",
                        }}
                      >
                        {itemCountage.comments != undefined
                          ? itemCountage.comments
                          : "-"}
                      </p>
                      <p className="textSecondaryListInventary">
                        {t("comments")}
                      </p>
                      <ReactTooltip id="comments" />
                    </div>
                  </>
                ) : (
                  <div
                    onClick={() => redirectToPage(itemCountage.id)}
                    style={{
                      width: "220px",
                      position: "absolute",
                      right: "-180px",
                      top: "37px",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        width: "4px",
                        height: "4px",
                        background: "black",
                        borderRadius: "100%",
                      }}
                    ></div>
                    <div
                      style={{
                        width: "4px",
                        height: "4px",
                        background: "black",
                        borderRadius: "100%",
                        marginTop: "2px",
                      }}
                    ></div>
                    <div
                      style={{
                        width: "4px",
                        height: "4px",
                        background: "black",
                        borderRadius: "100%",
                        marginTop: "2px",
                      }}
                    ></div>
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <p
                    data-tooltip-place="top"
                    data-tooltip-position-strategy="fixed"
                    data-tooltip-id="reasonErrors"
                    data-tooltip-content={`${itemCountage.reasonErrors}`}
                    className="textPrimartyListInventary"
                    style={{
                      width: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {itemCountage.reasonErrors != undefined
                      ? itemCountage.reasonErrors
                      : "-"}
                  </p>
                  <p className="textSecondaryListInventary">
                    {t("reasonErrors")}
                  </p>
                  <ReactTooltip id="reasonErrors" />
                </div>

                {optionAdm && (
                  <div
                    onClick={() =>
                      redirectToPage(itemCountage.id, true, "resume")
                    }
                    style={{
                      width: "220px",
                      position: "absolute",
                      right: "-185px",
                      top: "37px",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      style={{
                        width: "4px",
                        height: "4px",
                        background: "black",
                        borderRadius: "100%",
                      }}
                    ></div>
                    <div
                      style={{
                        width: "4px",
                        height: "4px",
                        background: "black",
                        borderRadius: "100%",
                        marginTop: "2px",
                      }}
                    ></div>
                    <div
                      style={{
                        width: "4px",
                        height: "4px",
                        background: "black",
                        borderRadius: "100%",
                        marginTop: "2px",
                      }}
                    ></div>
                  </div>
                )}

                {itemCountage.picture1 != undefined ? (
                  <img
                    onClick={() => {
                      setImageSrc(itemCountage.picture1);
                      setIsActiveModalImage(true);
                    }}
                    src={itemCountage.picture1}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "6px",
                      marginLeft: "20px",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <></>
                )}

                {itemCountage.picture2 != undefined ? (
                  <img
                    onClick={() => {
                      setImageSrc(itemCountage.picture2);
                      setIsActiveModalImage(true);
                    }}
                    src={itemCountage.picture2}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "6px",
                      marginLeft: "20px",
                    }}
                  />
                ) : (
                  <></>
                )}

                {itemCountage.picture3 != undefined ? (
                  <img
                    onClick={() => {
                      setImageSrc(itemCountage.picture3);
                      setIsActiveModalImage(true);
                    }}
                    src={itemCountage.picture3}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "6px",
                      marginLeft: "20px",
                    }}
                  />
                ) : (
                  <></>
                )}

                {itemCountage.picture4 != undefined ? (
                  <img
                    onClick={() => {
                      setImageSrc(itemCountage.picture4);
                      setIsActiveModalImage(true);
                    }}
                    src={itemCountage.picture4}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "6px",
                      marginLeft: "20px",
                    }}
                  />
                ) : (
                  <></>
                )}

                {itemCountage.picture5 != undefined ? (
                  <img
                    onClick={() => {
                      setImageSrc(itemCountage.picture5);
                      setIsActiveModalImage(true);
                    }}
                    src={itemCountage.picture5}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "6px",
                      marginLeft: "20px",
                    }}
                  />
                ) : (
                  <></>
                )}

                {itemCountage.picture6 != undefined ? (
                  <img
                    onClick={() => {
                      setImageSrc(itemCountage.picture6);
                      setIsActiveModalImage(true);
                    }}
                    src={itemCountage.picture6}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "6px",
                      marginLeft: "20px",
                    }}
                  />
                ) : (
                  <></>
                )}

                <ImageModal
                  image={imageSrc}
                  isActive={isActiveModalImage}
                  closeImg={() => setIsActiveModalImage(!isActiveModalImage)}
                />
              </div>
            );
          })}
      </div>
    </>
  );
};

export default TableListManager;
